"use client";
const r = {
  slots: {
    base: "relative inline-flex flex-col items-center justify-center gap-2",
    wrapper: "relative flex",
    label: "text-foreground dark:text-foreground-dark font-regular",
    circle1: [
      "absolute h-full w-full rounded-full",
      "animate-spin [animation-timing-function:ease]",
      "border-solid",
      "border-t-transparent",
      "border-l-transparent",
      "border-r-transparent"
    ],
    circle2: [
      "absolute h-full w-full rounded-full",
      "opacity-75",
      "animate-spin",
      "border-dotted",
      "border-t-transparent",
      "border-l-transparent",
      "border-r-transparent"
    ]
  },
  size: {
    xs: {
      wrapper: "h-4 w-4 ",
      circle1: "border-2",
      circle2: "border-2",
      label: "text-small"
    },
    sm: {
      wrapper: "h-5 w-5 ",
      circle1: "border-2",
      circle2: "border-2",
      label: "text-small"
    },
    md: {
      wrapper: "h-6 w-6",
      circle1: "border-2",
      circle2: "border-2",
      label: "text-medium"
    },
    lg: {
      wrapper: "h-8 w-8",
      circle1: "border-3",
      circle2: "border-3",
      label: "text-large"
    },
    xl: {
      wrapper: "h-9 w-9",
      circle1: "border-3",
      circle2: "border-3",
      label: "text-large"
    }
  },
  color: {
    current: {
      circle1: "border-b-current",
      circle2: "border-b-current"
    },
    white: {
      circle1: "border-b-white",
      circle2: "border-b-white"
    },
    regular: {
      circle1: "border-b-regular",
      circle2: "border-b-regular"
    },
    primary: {
      circle1: "border-b-primary",
      circle2: "border-b-primary"
    },
    secondary: {
      circle1: "border-b-secondary",
      circle2: "border-b-secondary"
    },
    success: {
      circle1: "border-b-success",
      circle2: "border-b-success"
    },
    warning: {
      circle1: "border-b-warning",
      circle2: "border-b-warning"
    },
    danger: {
      circle1: "border-b-danger",
      circle2: "border-b-danger"
    }
  },
  labelColor: {
    foreground: {
      label: "text-foreground"
    },
    primary: {
      label: "text-primary"
    },
    secondary: {
      label: "text-secondary"
    },
    success: {
      label: "text-success"
    },
    warning: {
      label: "text-warning"
    },
    danger: {
      label: "text-danger"
    }
  }
};
export {
  r as stylesSpinner
};
